import React from 'react';
import { reduxForm } from 'redux-form/immutable';

import { FormattedMessage } from 'react-intl';
import messages from '../messages';

import Spinner from 'Lib/spinner';

import SmsForm from '../forms/sms-check';
import AbroadForm from '../forms/abroad';
import SubmittedView from '../submitted';

import { Api } from '../api';
import { toast, ToastContainer } from 'react-toast';

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      submitted: false,
      hasErrors: false,
      errorMessage: <FormattedMessage {...messages.unknownError} />,
      result: {},
      smsChecking: false,
      smsCheckingDone: false,
      done: false,
      formData: undefined,
      phone: undefined,
      guid: undefined,
      phoneSettings: undefined,
      initialValues: {},
    };
    this.form = reduxForm({ ...this.props.formConfig })(AbroadForm);
  }

  handleSubmit = (formData) => {
    this.setState({ formData: formData });

    const { authorityId } = this.props.formConfig;
    const jsonFormData = this.prepareFormData(formData);
    jsonFormData['authority_id'] = authorityId;
    if (!jsonFormData['is_juridical']) {
      jsonFormData['juridical_name'] = null;
    }
    if (!!window.draftId) {
      Api.fetchSendDraft(jsonFormData, window.draftId).then(({ body }) => {
        window.draftId = body.id;
        if (body.status) {
          this.setState({
            hasErrors: false,
            done: true,
            smsChecking: false,
            result: { ...body, status: !body.status },
          });
        }
      });
    } else {
      Api.fetchSendDraft(jsonFormData).then(({ body }) => {
        window.draftId = body.id;
        this.setState({ draftId: body.id });
        if (body.status) {
          this.setState({
            hasErrors: false,
            done: true,
            smsChecking: false,
            result: { ...body, status: !body.status },
          });
        }
      });
    }
    this.makeSmsConfirmation();
  };
  handleSmsSubmit = (phone) => {
    this.setState({ phone: phone, smsChecking: false, smsCheckingDone: true });
    this.submit();
  };
  handlePhoneSettingsChange = (e, value) => {
    Api.fetchPhonePattern(value).then((resp) => {
      this.setState({ phoneSettings: JSON.parse(resp.body) });
    });
  };
  makeSmsConfirmation = () => {
    if (!this.state.smsCheckingDone) return this.setState({ smsChecking: true });
    return this.submit();
  };
  prepareFormData = () => {
    const { formConfig, prepareFormDataCb } = this.props;
    const formData = this.state.formData.toJS();
    formData[formConfig.formName]._csrf = window._csrf;
    formData[formConfig.formName].phone = this.state.phone;
    return prepareFormDataCb(formData[formConfig.formName]);
  };
  handleServerError = () =>
    this.setState({
      submitted: true,
      hasErrors: true,
      loading: false,
    });
  submit = () => {
    const { apiSubmitPromise, apiResponseOkHandleCb, apiResponseErrorHandleCb } = this.props;
    const formData = this.prepareFormData();
    this.setState({ loading: true });
    // api submit promise must conform the signature
    // func (formData, errorHandlerCb)
    apiSubmitPromise(formData, this.handleServerError).then((resp) => {
      // api response must conform the belove structure
      // {status: Boolean, error: String, result: {request_id, token}}
      const respBody = JSON.parse(resp.body);
      if (resp.ok && respBody.status) {
        this.setState({
          submitted: true,
          done: true,
          loading: false,
          result: respBody.result,
        });
        apiResponseOkHandleCb(resp);
      } else {
        this.setState({
          submitted: true,
          hasErrors: true,
          errorMessage: respBody.error,
          loading: false,
        });
        apiResponseErrorHandleCb(resp);
      }
    });
  };

  render() {
    const customStyle = {
      position: 'relative',
      borderTop: 'none',
    };
    const RegisteredForm = this.form;
    const { formConfig, authorityData } = this.props;
    const { loading, done, hasErrors, errorMessage, result, smsChecking, smsCheckingDone, phoneSettings } = this.state;

    return (
      <div className="over-bottom" style={customStyle}>
        {loading ? <Spinner /> : null}
        {!done || hasErrors ? (
          <span>
            {hasErrors
              ? toast(errorMessage || <FormattedMessage {...messages.formError} />, {
                  backgroundColor: '#f2dede',
                  color: '#a94442',
                })
              : null}
            <RegisteredForm
              onSubmit={this.handleSubmit}
              fileGuid={this.state.guid}
              fileFieldName="user_file"
              handleCountryChange={this.handlePhoneSettingsChange}
              formName={formConfig.formName}
            />
          </span>
        ) : (
          <SubmittedView authorityData={authorityData} code={result.request_id} token={result.token} />
        )}
        {smsChecking && (
          <SmsForm handleSmsCheck={this.handleSmsSubmit} done={smsCheckingDone} phoneSettings={phoneSettings} />
        )}
        <ToastContainer delay={4000} position="top-right" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/application-form/form-managers/abroad-form.js